import React from 'react';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import shouldUpdate from 'utils/shouldUpdate';

const defaultTrigger = ['hover', 'focus'];

function DataPopover({
  children,
  tooltipMessage,
  tooltipClass = undefined,
  trigger = defaultTrigger,
  placement = 'bottom',
  ...rest
}) {
  if (!tooltipMessage) {
    return children;
  } else if (typeof tooltipMessage === 'string') {
    tooltipMessage = tooltipMessage
      .split('\n')
      .map((text, index) => <div key={index}>{text}</div>);
  }
  return (
    <OverlayTrigger
      trigger={trigger}
      placement={placement}
      overlay={
        <Tooltip className={tooltipClass} id="tooltip">
          {tooltipMessage}
        </Tooltip>
      }
      {...rest}
    >
      {/* OverlayTrigger expects one child, which it will attach mouse handlers to, */}
      {/* Wrap a custom conponent in an extra div is required */}
      {/* so the child you pass must be an interactive element (like a button) */}
      <div className="tooltip-children-container">{children}</div>
    </OverlayTrigger>
  );
}

function shouldComponentUpdate(props, nextProps) {
  return (
    props.children !== nextProps.children ||
    props.tooltipMessage !== nextProps.tooltipMessage ||
    props.tooltipClass !== nextProps.tooltipClass ||
    props.trigger !== nextProps.trigger ||
    props.placement !== nextProps.placement
  );
}

export default shouldUpdate(shouldComponentUpdate)(DataPopover);
